import {
  ADD_EMPTY_EDITABLE_CONTENT,
  DELETE_EDITABLE_CONTENT,
  GET_CITIES,
  GET_LINKS,
  RESET_STATE,
  SET_CITY,
  SET_COMPANIES_DATA,
  SET_CURRENT_PAGE_TYPE,
  SET_EDITABLE_CONTENT,
  SET_LINKS,
  SET_LOADING,
  SET_RATINGS,
  SET_SHOULD_REDIRECT_TO_THE_MAIN_PAGE,
  SET_TRIP_DATA,
} from './constants';

/**
 * @description Retrieves trip data from API
 * @param {string} origin - Origin city name
 * @param {string} destination - Destination city name
 * @returns {{origin: string, destination: string, type: string}}
 */
export function getCitiesAction(origin, destination, pageType) {
  return {
    type: GET_CITIES,
    origin,
    destination,
    pageType,
  };
}

/**
 * @description Retrieves links from API
 * @param {string} direction - Direction of the links requested (FROM | TO)
 * @param {string} linkType - What category of links (FROM_ORIGIN_LINKS | TO_ORIGIN_LINKS | FROM_DESTINATION_LINKS | TO_DESTINATION_LINKS)
 * @param {string} slug - City slug (unique name)
 * @param {number} [number] - Number of links requested
 * @returns {{number: number, linkType: string, type: string, slug: string, direction: string}}
 */
export function getLinksAction(direction, linkType, slug, number) {
  return {
    type: GET_LINKS,
    direction,
    linkType,
    slug,
    number,
  };
}

/**
 * @description Update the city basic information
 * @param {string} cityType -  Which city to update : ORIGIN_CITY || DESTINATION_CITY
 * @param {object} city - City data retrieved from API
 * @returns {{cityType: string, city: object, type: string}}
 */
export function setCityAction(cityType, city) {
  return {
    type: SET_CITY,
    cityType,
    city,
  };
}

/**
 * @description Update the links of one type
 * @param {string} direction - Direction of the links requested (FROM | TO)
 * @param {string} linkType - What category of links to update (FROM_ORIGIN_LINKS | TO_ORIGIN_LINKS | FROM_DESTINATION_LINKS | TO_DESTINATION_LINKS)
 * @param {{unique_name: string, city_id: number, local_name:number}[]} links - Links retrieved from API
 * @returns {{linkType: string, links: {unique_name: string, city_id: number, local_name:number}[], type: string}}
 */
export function setLinksAction(direction, linkType, links) {
  return {
    type: SET_LINKS,
    direction,
    linkType,
    links,
  };
}

/**
 * @description Set state tripData from API
 * @param {object} tripData - Trip data from API
 * @returns {{tripData: *, type: string}}
 */
export function setTripDataAction(tripData) {
  return {
    type: SET_TRIP_DATA,
    tripData,
  };
}

/**
 * @description Updates the loading state
 * @param {boolean} value - Loading state
 * @returns {{type: string, value: boolean}}
 */
export function setLoadingAction(value) {
  return {
    type: SET_LOADING,
    value,
  };
}

/**
 * @description Update state with editableContent
 * @param {Array} content - Editable content retrieved from API
 * @returns {{type: string, content: Array}}
 */
export function setEditableContentAction(content) {
  return {
    type: SET_EDITABLE_CONTENT,
    content,
  };
}

/**
 * @description Adds an empty editable content to the state.
 */
export function addEmptyEditableContentAction() {
  return {
    type: ADD_EMPTY_EDITABLE_CONTENT,
  };
}

/**
 * @description Delete the editable content with the `priority` provided from the state.
 * @param {number} priority
 * @returns {{type: string, content: number}}
 */
export function deleteEditableContentAction(priority) {
  return {
    type: DELETE_EDITABLE_CONTENT,
    priority,
  };
}

/**
 * @description Reset state to initial state
 * @returns {{type: string}}
 */
export function resetStateAction() {
  return {
    type: RESET_STATE,
  };
}

/**
 * @description Update state with ratings from API
 * @param {Object} ratings - Ratings data retrieved from API
 * @returns {{ratings: Object, type: string}}
 */
export function setRatingsAction(ratings) {
  return {
    type: SET_RATINGS,
    ratings,
  };
}

export function setCurrentPageTypeAction(pageType) {
  return {
    type: SET_CURRENT_PAGE_TYPE,
    pageType,
  };
}

export function setShouldRedirectToTheMainPage(shouldRedirectToMainPage) {
  return {
    type: SET_SHOULD_REDIRECT_TO_THE_MAIN_PAGE,
    shouldRedirectToMainPage,
  };
}

export function setCompaniesData(companiesData) {
  return {
    type: SET_COMPANIES_DATA,
    companiesData,
  };
}
